import React, { useEffect, useState }  from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import "../../../Dashboard/dashboard.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Modal from "@material-ui/core/Modal";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BVAButton from "../../../../components/BVAButton/BVAButton";
import {generateCapitalizationRate, updateCapitalizationRate} from "../../../../store/modules/capitalizationRate/actions";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import FinancialHandler from "../../../../handlers/FinancialHandler";
import "../modal.css";
import AutoComplete from "./AutoComplete";
import sizeData from "./Size_Premium_2024.json";
import countryData from "./Country_Risk_Data_2024.json";
import industryDamodaranData from "./Industry_Premium_Damodaran_2024.json";
import industrySalvidioData from "./Industry_Premium_Salvidio_2024.json";

const AFTERTAX = "AFTERTAX"
const BEFORETAX = "PRETAX"

const CapitalizationRate = ({
  capitalizationRate,
  appState,
  dispatchGenerateCapitalizationRate,
  dispatchUpdateCapitalizationRate
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateCapitalizationRate()
  }, [])
  const [selection, setSelection] = useState(AFTERTAX);
  const [modalData, setModalData] = useState(false);

  //a11yProps
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // Methods
  const handleChange = (value, type, key) => {
    dispatchUpdateCapitalizationRate({ [type]: { [key]: CurrencyFormatter.unformat(value, { code: "USD" }) } })
  };

  const handleAnalystNoteOnChange = (value) => {
    dispatchUpdateCapitalizationRate({ analystNote: value })
  }

  const handleNotesOnChange = (value, key) => {
    dispatchUpdateCapitalizationRate({ afterTaxCapitalizationRate: { [key]: value }})
  }

  const handleModalClose = () => setModalData(false);

  const handleModalSet = (data) => {
    if(data.type === "sizePremium") data.options = sizeData;
    else if(data.type === "countryRisk") data.options = countryData;
    else if(data.type === "industryRisk_Damodaran")   //if we have SIC, filter the list
      data.options = (data.SIC ? industryDamodaranData.filter((obj) => obj["4 Digit SIC"] === data.SIC) : industryDamodaranData);
    else if(data.type === "industryRisk_Salvidio")   //if we have SIC, filter the list
      data.options = (data.SIC ? industrySalvidioData.filter((obj) => obj["SIC Code"] === data.SIC) : industrySalvidioData);
    setModalData(data);
  }

  const handleOnClickGPT = async () => {
    handleAnalystNoteOnChange("Generating...");
    const note = await FinancialHandler.fetchGPTCapitalizationNoteGeneration(
      capitalizationRate.preTaxCapitalizationRate,
      capitalizationRate.afterTaxCapitalizationRate
    );
    handleAnalystNoteOnChange(note);
  }

  const handleOnClickSearchGPT = async ({ type }) => {
    const name = type === "riskFreeRate" ? "10 year treasury bond rate" : "Damodaran equity risk premium";
    const link = type === "riskFreeRate" ?
      "https://ycharts.com/indicators/10_year_treasury_rate" : "https://pages.stern.nyu.edu/adamodar/New_Home_Page/home.htm";
      //equity risk premium was originally "https://ycharts.com/indices/%5ESPUSERPTR"
    const payload = `${link}\nPlease visit this link and let me know ${name} today`;

    let value = await FinancialHandler.fetchGPTSearchRate(payload);
    handleChange(value, "afterTaxCapitalizationRate", type);
  }

  return (
    <>
      <Modal className="modal" onClose={handleModalClose} open={modalData}>
        <div className="modal-main">
          {modalData?.type?.includes("industryRisk") &&
            <div className="flex justify-center mb-5">
              <Tabs
                value={modalData?.type === "industryRisk_Damodaran" ? 0 : 1}
                onChange={(e, value) => handleModalSet({
                  type: value ? "industryRisk_Salvidio" : "industryRisk_Damodaran",
                  fieldName: "Industry",
                  resultName: (value ? "" : "Implied ") + "Industry Risk Premium",
                  SIC: ""
                })}
                aria-label="basic tabs example"
              >
                <Tab label="Damodaran" {...a11yProps(0)} />
                <Tab label="Salvidio" {...a11yProps(1)} />
              </Tabs>
            </div>
          }
          <div className="flex justify-center mx-20">
            <AutoComplete
              options={modalData.options}
              fieldName={modalData.fieldName}
              onChange={(value) => setModalData({ ...modalData, selected: value })} //put selected object from options array
            />
          </div>
          {modalData?.type?.includes("industryRisk") &&
            <div className="flex justify-center items-center text-xl my-3">
              <div className="mr-2">SIC:</div>
              <div style={{ maxWidth: "9rem" }}>
                <BVAInput
                  size="small"
                  textAlign="start"
                  id="sic-code"
                  onChange={(value) => handleModalSet({ ...modalData, SIC: value.replace(",", "") })}
                />
              </div>
            </div>
          }
          {modalData.type === "sizePremium" && modalData.selected &&
            <div className="mt-6 mx-12 text-lg">
              <div className="flex justify-between">
                <div>Min Size:</div>
                <div>{modalData.selected["Minium Size"]}</div>
              </div>
              <div className="flex justify-between">
                <div>Max Size:</div>
                <div>{modalData.selected["Maxium Size"]}</div>
              </div>
            </div>
          }
          <div className="flex justify-end mr-12 mt-12">
            <BVAButton
              kind="primary-outlined"
              height="40px"
              onClick={() => {
                modalData.selected && handleChange(
                  modalData.selected[modalData.resultName],
                  "afterTaxCapitalizationRate",
                  modalData.type.split('_')[0] //get the part before '_' in string, which indicates the input field key
                );
                handleModalClose();
              }}>
                OK
            </BVAButton>
          </div>
        </div>
      </Modal>
      
      <div className="flex items-center justify-between pr-20">
        <h2 className="sectionHead">Capitalization Rate</h2>
        <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
          <InputLabel id="demo-simple-select-standard-label">Build-Up Method</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={selection}
            onChange={(e) => setSelection(e.target.value)}
            label="Build-Up Method"
          >
            <MenuItem value={AFTERTAX}>After-Tax Rate</MenuItem>
            <MenuItem value={BEFORETAX}>Before-Tax Rate</MenuItem>
          </Select>
        </FormControl>
      </div>
    
      <div className="dashboard-content" style={{ minWidth: "70em" }}>
        <div className="mt-7 pb-5" style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold", color: "black" }}>
              Capitalization Rate Components
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <InputLabel style={{ fontWeight: "bold", color: "black", marginLeft: "6%" }}>
              Percent (%)
            </InputLabel>
            <InputLabel style={{ fontWeight: "bold", color: "black", marginLeft: "35%" }}>
              Comments
            </InputLabel>
          </div>
        </div>

        {selection == AFTERTAX ?
          (<>
            <div style={rowStyle.baseRow}>
              <div style={rowStyle.GPTlabelRow}>
                <InputLabel>Risk Free Rate</InputLabel>
                <button
                  style={rowStyle.GPTRow}
                  onClick={() => handleOnClickSearchGPT({ type: "riskFreeRate" })}
                >
                  🤖
                </button>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-afterTaxcapitalizationRate-riskFreeRate"
                  endAdornment
                  endAdornmentLabel="%"
                  onBlur={(value) => handleChange(value, "afterTaxCapitalizationRate", "riskFreeRate")}
                  value={capitalizationRate?.afterTaxCapitalizationRate?.riskFreeRate?.toFixed(2)}
                />
                <TextareaAutosize
                  style={rowStyle.notes}
                  aria-label="minimum height"
                  minRows={1}
                  maxRows={1}
                  defaultValue={capitalizationRate?.afterTaxCapitalizationRate?.riskFreeRateNote}
                  onBlur={(e) => handleNotesOnChange(e.target.value, "riskFreeRateNote")}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.GPTlabelRow}>
                <InputLabel>Equity Risk Premium</InputLabel>
                <button
                  style={rowStyle.GPTRow}
                  onClick={() => handleOnClickSearchGPT({ type: "equityRiskPremium" })}
                >
                  🤖
                </button>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-afterTaxCapitalizationRate-equityRiskPremium"
                  endAdornment
                  endAdornmentLabel="%"
                  onBlur={(value) => handleChange(value, "afterTaxCapitalizationRate", "equityRiskPremium")}
                  value={capitalizationRate?.afterTaxCapitalizationRate?.equityRiskPremium?.toFixed(2)}
                />
                <TextareaAutosize
                  style={rowStyle.notes}
                  aria-label="minimum height"
                  minRows={1}
                  maxRows={1}
                  defaultValue={capitalizationRate?.afterTaxCapitalizationRate?.equityRiskPremiumNote}
                  onBlur={(e) => handleNotesOnChange(e.target.value, "equityRiskPremiumNote")}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.GPTlabelRow}>
                <InputLabel>Size Premium</InputLabel>
                <button
                  style={rowStyle.GPTRow}
                  onClick={() => handleModalSet(
                    { type: "sizePremium", fieldName: "Decile", resultName: "Size Premium" }
                  )}
                >
                  <AnalyticsIcon />
                </button>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-afterTaxCapitalizationRate-sizePremium"
                  endAdornment
                  endAdornmentLabel="%"
                  onBlur={(value) => handleChange(value, "afterTaxCapitalizationRate", "sizePremium")}
                  value={capitalizationRate?.afterTaxCapitalizationRate?.sizePremium?.toFixed(2)}
                />
                <TextareaAutosize
                  style={rowStyle.notes}
                  aria-label="minimum height"
                  minRows={1}
                  maxRows={1}
                  defaultValue={capitalizationRate?.afterTaxCapitalizationRate?.sizePremiumNote}
                  onBlur={(e) => handleNotesOnChange(e.target.value, "sizePremiumNote")}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.GPTlabelRow}>
                <InputLabel>Industry Risk</InputLabel>
                <button
                  style={rowStyle.GPTRow}
                  onClick={() => handleModalSet(
                    { type: "industryRisk_Damodaran", fieldName: "Industry", resultName: "Implied Industry Risk Premium" }
                  )}
                >
                  <AnalyticsIcon />
                </button>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-afterTaxCapitalizationRate-industryRisk"
                  endAdornment
                  endAdornmentLabel="%"
                  onBlur={(value) => handleChange(value, "afterTaxCapitalizationRate", "industryRisk")}
                  value={capitalizationRate?.afterTaxCapitalizationRate?.industryRisk?.toFixed(2)}
                />
                <TextareaAutosize
                  style={rowStyle.notes}
                  aria-label="minimum height"
                  minRows={1}
                  maxRows={1}
                  defaultValue={capitalizationRate?.afterTaxCapitalizationRate?.industryRiskNote}
                  onBlur={(e) => handleNotesOnChange(e.target.value, "industryRiskNote")}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.GPTlabelRow}>
                <InputLabel>Country Risk</InputLabel>
                <button
                  style={rowStyle.GPTRow}
                  onClick={() => handleModalSet(
                    { type: "countryRisk", fieldName: "Country", resultName: "Country Risk Premium" }
                  )}
                >
                  <AnalyticsIcon />
                </button>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-afterTaxCapitalizationRate-countryRisk"
                  endAdornment
                  endAdornmentLabel="%"
                  onBlur={(value) => handleChange(value, "afterTaxCapitalizationRate", "countryRisk")}
                  value={capitalizationRate?.afterTaxCapitalizationRate?.countryRisk?.toFixed(2)}
                />
                <TextareaAutosize
                  style={rowStyle.notes}
                  aria-label="minimum height"
                  minRows={1}
                  maxRows={1}
                  defaultValue={capitalizationRate?.afterTaxCapitalizationRate?.countryRiskNote}
                  onBlur={(e) => handleNotesOnChange(e.target.value, "countryRiskNote")}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Risk Premium for Company Specific Risks</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  textAlign="end"
                  size="small"
                  id="caprate-afterTaxcapitalizationRate-riskPremiumCompanySpecificRisks"
                  endAdornment
                  endAdornmentLabel="%"
                  onBlur={(value) => handleChange(value, "afterTaxCapitalizationRate", "riskPremiumCompanySpecificRisks")}
                  value={capitalizationRate?.afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisks?.toFixed(2)}
                />
                <TextareaAutosize
                  style={rowStyle.notes}
                  aria-label="minimum height"
                  minRows={1}
                  maxRows={1}
                  defaultValue={capitalizationRate?.afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisksNote}
                  onBlur={(e) => handleNotesOnChange(e.target.value, "riskPremiumCompanySpecificRisksNote")}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  After-Tax Net Cash Flow Discount Rate
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  id="caprate-afterTaxCapitalizationRate-afterTaxNetCashFlowDiscountRate"
                  textAlign="end"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.afterTaxCapitalizationRate?.afterTaxNetCashFlowDiscountRate?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Long-Term Sustainable Growth Rate</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  textAlign="end"
                  size="small"
                  id="caprate-afterTaxCapitalizationRate-longTermSustainableGrowthRate"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.afterTaxCapitalizationRate?.longTermSustainableGrowthRate?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  After-Tax Net Cash Flow Capitalization Rate
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  id="caprate-afterTaxCapitalizationRate-afterTaxNetCashFlowCapitalizationRate"
                  textAlign="end"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.afterTaxCapitalizationRate?.afterTaxNetCashFlowCapitalizationRate?.toFixed(2)}
                />
              </div>
            </div>
          </>)
          :
          (<>
            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>After-Tax Free Cash Flow</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  textAlign="end"
                  size="small"
                  id="caprate-preTaxCapitalizationRate-afterTaxFreeCashFlow-2"
                  disabled
                  endAdornment
                  endAdornmentLabel="$"
                  value={capitalizationRate?.preTaxCapitalizationRate?.afterTaxFreeCashFlow?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Pre-Tax Free Cash Flow</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  id="caprate-preTaxCapitalizationRate-preTaxFreeCashFlowTwo"
                  textAlign="end"
                  disabled
                  endAdornment
                  endAdornmentLabel="$"
                  value={capitalizationRate?.preTaxCapitalizationRate?.preTaxFreeCashFlow?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>After-Tax to Pre-Tax Ratio (%)</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  id="caprate-preTaxCapitalizationRate-ratioAfterToPreTax"
                  disabled
                  textAlign="end"
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.preTaxCapitalizationRate?.ratioAfterToPreTax?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>
                  After-Tax Net Cash Flow Capitalization Rate (%)
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  id="caprate-preTaxCapitalizationRate-afterTaxNetCashFlowCapitalizationRate"
                  textAlign="end"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.preTaxCapitalizationRate?.afterTaxNetCashFlowCapitalizationRate?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>After-Tax to Pre-Tax Ratio (%)</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-preTaxCapitalizationRate-ratioAfterToPreTax-2"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.preTaxCapitalizationRate?.ratioAfterToPreTax?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Pre-Tax Net Cash Flow Capitalization Rate (%)
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-preTaxcapitalizationRate-preTaxNetCashFlowCapitalizationRate"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.preTaxCapitalizationRate?.preTaxNetCashFlowCapitalizationRate?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Plus: Long-Term Growth Rate (%)</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-preTaxcapitalizationRate-growthRate"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.afterTaxCapitalizationRate?.longTermSustainableGrowthRate?.toFixed(2)}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Pre-Tax Net Cash Flow Discount Rate (%)
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  textAlign="end"
                  id="caprate-preTaxcapitalizationRate-preTaxNetCashFlowDiscountRate"
                  disabled
                  endAdornment
                  endAdornmentLabel="%"
                  value={capitalizationRate?.preTaxCapitalizationRate?.preTaxNetCashFlowDiscountRate?.toFixed(2)}
                />
              </div>
            </div>
          </>)
        }
        <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
          <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
          <textarea
            className="analystNote"
            rows={3}
            value={capitalizationRate?.analystNote}
            onChange={(e) => handleAnalystNoteOnChange(e.target.value)}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    capitalizationRate: state.capitalizationRate.capitalizationRate,
    appState: state.appState,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateCapitalizationRate() {
    dispatch(generateCapitalizationRate())
  },

  dispatchUpdateCapitalizationRate({ analystNote, afterTaxCapitalizationRate, preTaxCapitalizationRate }) {
    dispatch(updateCapitalizationRate({ analystNote, afterTaxCapitalizationRate, preTaxCapitalizationRate }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CapitalizationRate);
